import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var inputData = {
  name: 'input',
  data: [{
    multipleBlockBgColor: '#29BECE',
    multipleBlockColor: '#ffffff',
    disabledMultipleBlockBgColor: 'rgba(0, 0, 0, 0.25)',
    requiredBgColor: '#feffe6',
    invalidBgColor: '#fcebeb',
    groupBgColor: '#eee',
    groupBorderColor: '#d9d9d9',
    radius: 4,
    labelColor: '#333',
    noPadding: '',
    normalPadding: '',
    tdPaddingTop: 0,
    // 与组件库默认样式保持一致
    verticalLabelPaddingLeft: '',
    verticalWrapperPaddingLeft: '',
    verticalWrapperPaddingBottom: '',
    inputWrapperBorderRadius: 4,
    placeholderColor: '#bfbfbf'
  }],
  fusionTemplate: true,
  onlyTemplate: {
    pro: function pro(props) {
      var _getThemeData = getThemeData(props, 'common'),
        defaultIconfontFamily = _getThemeData.defaultIconfontFamily;
      return css([".c7n-pro-input-multiple.c7n-pro-input-multiple.c7n-pro-input-multiple > label > div > ul > li[class*='multiple-block'] .icon.icon-cancel::before{content:'\\E5C9';font-family:", ";}"], defaultIconfontFamily);
    }
  }
};
export default inputData;